import { ApolloClient, InMemoryCache } from "@apollo/client";
import { apolloLink } from "./fetchWithRefresh";
import { relayStylePagination } from "@apollo/client/utilities";

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        pages: relayStylePagination(),
      },
    },
  },
});

export const client = new ApolloClient({
  link: apolloLink,
  cache: cache,
});
